import { Super } from './super.model';

export class ProSituation extends Super<ProSituation> {

    public name: string;
    public description: string;
    public weight: number;
    
}